"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fontWeightBlack = exports.fontWeightExtraBold = exports.fontWeightBold = exports.fontWeightSemiBold = exports.fontWeightMedium = exports.fontWeightRegular = void 0;
exports.fontWeightRegular = 400;
exports.fontWeightMedium = 500;
exports.fontWeightSemiBold = 600;
exports.fontWeightBold = 700;
exports.fontWeightExtraBold = 800;
exports.fontWeightBlack = 900;